// extracted by mini-css-extract-plugin
module.exports = {"emptyResultsContainer":"_2xI7k2IAfzZYIsDbtyKPaU"};